import React from "react";
import { Autocomplete } from "../componentsList";

const SearchInput = ({
  inputID,
  placeHolder,
  classes,
  suggestions,
  storeInput,
  defaultValueForInput,
  useGeo,
  label,
  tooltipIcon
}) => {
  return (
    <div className={`field ${classes}`}>
      {label && <label>{label}</label>}
      <div className="autocomplete-container input">
        <Autocomplete
          placeholder={placeHolder}
          filterID={inputID}
          suggestions={suggestions}
          storeInput={storeInput}
          defaultValueForInput={defaultValueForInput}
          useGeo={useGeo}
          tooltipIcon={tooltipIcon}
        />
      </div>
    </div>
  );
};

export { SearchInput };
